import Information from './components/Information';
import Password from './components/Password';
import Card from 'components/card';
import { useEffect, useState } from 'react';
import GoBack from 'components/actions/GoBack';
import UpdateSellerInvoiceInformation from './components/UpdateSellerInvoiceInformation';
import UpdateBuyerInvoiceInformation from './components/UpdateBuyerInvoiceInformation';
import { CONFIG } from 'variables/config';
import axios from 'axios';

type TabType = 'account' | 'invoice' | 'security' | 'integration' | 'danger';

const ProfileSetting = () => {
    const [wantToDelete, setWantToDelete] = useState(false);
    const [user, setUser] = useState(null);
    const [activeTab, setActiveTab] = useState<TabType>('account');

    const initUser = () => {
        const token = localStorage.getItem('token');
        const config = {
            headers: { Authorization: `Bearer ${token}` },
        };
        axios
            .get(`${CONFIG.apiUrl}/user/me`, config)
            .then((res) => {
                const user = res.data;
                setUser(user);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        initUser();
    }, []);

    const tabs = [
        { id: 'account' as TabType, label: 'Compte', icon: '👤' },
        { id: 'invoice' as TabType, label: 'Facturation', icon: '📄' },
        { id: 'security' as TabType, label: 'Sécurité', icon: '🔒' },
        ...(user?.type === 'seller' ? [{ id: 'integration' as TabType, label: 'Intégration', icon: '🔗' }] : []),
        { id: 'danger' as TabType, label: 'Zone de danger', icon: '⚠️' },
    ];

    return (
        <>
            <div className="flex">
                <GoBack />
            </div>
            <div className="mt-3 w-full">
                {/* Tab Navigation */}
                <Card extra="w-full px-4 py-3 border-2">
                    <div className="flex flex-wrap gap-2">
                        {tabs.map((tab) => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-medium transition-all duration-200 ${
                                    activeTab === tab.id
                                        ? 'bg-leadrs text-white shadow-md'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-navy-700 dark:text-gray-300 dark:hover:bg-navy-600'
                                }`}
                            >
                                <span className="text-base">{tab.icon}</span>
                                <span>{tab.label}</span>
                            </button>
                        ))}
                    </div>
                </Card>

                {/* Tab Content */}
                <div className="mt-4">
                    {activeTab === 'account' && (
                        <div>
                            <Information />
                        </div>
                    )}

                    {activeTab === 'invoice' && (
                        <div>
                            {user?.type === 'buyer' && <UpdateBuyerInvoiceInformation />}
                            {user?.type === 'seller' && <UpdateSellerInvoiceInformation />}
                        </div>
                    )}

                    {activeTab === 'security' && (
                        <div>
                            <Password />
                        </div>
                    )}

                    {activeTab === 'integration' && user?.type === 'seller' && (
                        <div>
                            <Card extra="!flex-row py-4 px-5 justify-between items-center w-full border-2">
                                <div>
                                    <h3 className="text-base font-bold text-navy-700 dark:text-white">
                                        Tester mon intégration
                                    </h3>
                                    <p className="mt-2 text-sm text-gray-600">
                                        Vous pouvez à tout moment tester la
                                        connexion entre votre landing page et
                                        leadrs.co.
                                    </p>
                                    <p className="mt-2 text-sm text-gray-600">
                                        Pour se faire indiquer la valeur{' '}
                                        <b>'testing@leadrs.co'</b> dans n'importe
                                        lequel des champs de votre formulaire.
                                    </p>
                                    <p className="mt-2 text-sm text-gray-600">
                                        Si vous êtes correctement intégré vous
                                        recevrez un mail de confirmation, sinon
                                        modifiez l'url de votre landing page et
                                        suivez le guide pour rétablir la connexion.
                                    </p>
                                </div>
                            </Card>
                        </div>
                    )}

                    {activeTab === 'danger' && (
                        <div>
                            <Card extra="!flex-row py-4 px-5 justify-between items-center w-full border-2 border-red-200">
                                <div>
                                    <h3 className="text-base font-bold text-navy-700 dark:text-white">
                                        Supprimer ce compte
                                    </h3>
                                    <p className="text-sm text-gray-600">
                                        Attention cette action est irréversible
                                    </p>
                                    {wantToDelete && (
                                        <div className="mt-3">
                                            <p className="text-xs text-red-500">
                                                Vous pouvez faire supprimer votre compte en
                                                envoyant un mail à l'adresse suivante:
                                                charlotte@leadrs.co
                                            </p>
                                        </div>
                                    )}
                                </div>
                                <button
                                    className="linear flex cursor-pointer items-center justify-center rounded-lg border border-red-500 px-3 py-1.5 text-sm font-medium text-red-500 transition duration-200 hover:bg-red-50 active:bg-red-100 dark:active:bg-red-50 dark:active:opacity-80"
                                    onClick={() => setWantToDelete(!wantToDelete)}
                                >
                                    Supprimer
                                </button>
                            </Card>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default ProfileSetting;
